// eslint-disable-next-line no-extend-native
Array.prototype.appendToArray = function (elements, shouldAppend) {
	if (shouldAppend && Array.isArray(elements)) {
		this.push(...elements);
	}
	return this;
};
